import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Target',
      title: 'Personalized Learning',
      description: 'Get customized interview preparation plans tailored to your career goals and skill level'
    },
    {
      icon: 'TrendingUp',
      title: 'Track Your Progress',
      description: 'Monitor your improvement with detailed analytics and performance metrics over time'
    },
    {
      icon: 'Award',
      title: 'Expert Resources',
      description: 'Access premium content, mock interviews, and industry-specific preparation materials'
    },
    {
      icon: 'Users',
      title: 'Community Support',
      description: 'Connect with peers, share experiences, and learn from successful interview stories'
    }
  ];

  return (
    <div className="mt-8 md:mt-12 lg:mt-16">
      <div className="text-center mb-6 md:mb-8 lg:mb-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
          Why Join EduInterview Pro?
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
          Unlock powerful features designed to accelerate your interview preparation and career success
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-md hover:shadow-lg transition-base"
          >
            <div className="flex items-start space-x-3 md:space-x-4">
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={benefit?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-2 md:mb-3">
                  {benefit?.title}
                </h3>
                <p className="text-xs md:text-sm lg:text-base text-muted-foreground leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsSection;